// extracted by mini-css-extract-plugin
export default {"rating":"bI-z","numberOfStars":"cI-z","count":"dI-z","barGraphSpacing":"eI-z","barGraph":"fI-z"};